// Portabilite.vue

<template>
  <v-container>
    <v-row>
      <v-col cols="8">
        <h1>Conservation du numéro fixe</h1>
      </v-col>
      <v-col cols="4" class="text-right">
        <v-btn to="/souscription/offresbox/eligibilite/choixoffreoption">Retour</v-btn>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <br />
    <br />
    <br />

    <v-row>
      <v-col cols="12" sm="12" md="6">
        <span class="para">Souhaitez-vous conserver votre numéro de téléphone fixe actuel ?</span>
      </v-col>
      <v-col cols="12" sm="12" md="6" id="reponse">
        <v-btn
          class="pl-10 pr-10 font-weight-black"
          :class="{ sel: isConservNum('O')}"
          @click="ChoixConservNum('O')"
        >Oui</v-btn>
        <v-btn
          class="ml-12 pl-10 pr-10 font-weight-black"
          :class="{ sel: isConservNum('N')}"
          @click="ChoixConservNum('N')"
        >Non</v-btn>
      </v-col>
    </v-row>

    <br />
    <br />

    <v-row justify="center" v-if="conservNum=='O'">
      <v-col cols="12" sm="8" md="8" lg="8">
        <v-text-field
          label="Numéro de téléphone fixe actuel"
          prepend-icon="mdi-phone-dial"
          outlined
          v-model="numFixe"
          maxlength="10"          
          clearable
          type="number"
          :rules="[rules.required, rules.minMax10]"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row justify="center" v-if="conservNum=='O'">
      <v-col cols="12" sm="8" md="8" lg="8">
        <v-text-field
          label="Code RIO"
          prepend-icon="mdi-cellphone-key"
          hint="Si vous êtes chez un autre opérateur"
          persistent-hint
          outlined
          clearable
          maxlength="12"
          :rules="[ rules.minMax12]"
          v-model="codeRIO"
        ></v-text-field>
      </v-col>
    </v-row>

    <br />
    <br />
    <br />

    <v-row v-if="conservNum=='O'">
      <v-spacer></v-spacer>
      <v-col cols="4" class="text-right">
        <v-btn class="poursuivre" :loading="loading" @click="validationPorta()">Poursuivre</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { PortabiliteService } from "../../../../providers/PortabiliteService";
const portabiliteService = new PortabiliteService();
export default {
  data() {
    return {         
      loading:false,
      conservNum: null,
      numFixe: null,
      codeRIO: null,
      offreChoisieType: null,
      rules: {
        required: value => !!value || 'Numéro obligatoire.',
        minMax10: v => (v && v.length == 10) || 'Numero à 10 chiffres',
        minMax12: v => (v && v.length == 12) || '12 caractères',
      }
    };
  },
  mounted: async function () {
    this.initPortabiliteFromSession();
  },
  methods: {
    ChoixConservNum: function (choix) {
      this.conservNum = choix;

      // enregistrement du choix en session
      const sessionSouscriptionConservNum = this.$globalService.setSessionSouscription(
        "conservNum",
        this.conservNum
      );
      if (
        sessionSouscriptionConservNum == null ||
        !sessionSouscriptionConservNum.conservNum
      ) {
        this.$dialog.error({
          text: "Une erreur s'est produite",
          title: "Erreur",
          persistent: false,
          actions: {
            false: "Fermer",
          },
        });
        return;
      }

      if (this.conservNum == "N") {
        // raz numFixe et codeRIO si préalablement enregistrés
         var sessionSouscription = this.$globalService.getSessionSouscription();
        if(sessionSouscription != null){
          delete sessionSouscription.numFixe;
          delete sessionSouscription.codeRIO;
          if( sessionSouscription.resultCheckRio){
            delete sessionSouscription.resultCheckRio;
            
          }
        }
        this.$globalService.setSessionStorageId('souscription', sessionSouscription);
        this.$router.push({ name: "Recap" });
      }
    },
    isConservNum: function (choix) {
      if (this.conservNum == choix) {
        return true;
      } else {
        return false;
      }
    },
    initPortabiliteFromSession: function () {
      var sessionSouscription = this.$globalService.getSessionSouscription();
      if (sessionSouscription != null) {        
        this.conservNum = sessionSouscription.conservNum;        
        this.numFixe = sessionSouscription.numFixe;
        this.codeRIO = sessionSouscription.codeRIO;
        this.offreChoisieType = sessionSouscription.offreChoisie.type;

      }
    },
    validationPorta: function () {
      //verification de la faisabilite porta (isClient SFR et isValidRio)
      if (!this.numFixe) {
        this.$dialog.warning({
          text: "Veuillez renseigner le numéro de téléphone fixe actuel",
          title: "Attention",
          persistent: false,
          actions: {
            false: "Fermer",
          },
        });
        return;
      }else{

        this.loading = true;
      portabiliteService.checkRio(this.numFixe,this.codeRIO,this.$root.user.domaine,this.$root.user.site,this.offreChoisieType).then((res) => {
        console.log("checkRio");
           this.loading = false;
          if (res) {
            if (res.err != "error" && res.params) {
              const resultCheckRio = res.params;
              if(res.params.contrat && res.params.contrat !='' && res.params.titulaire && res.params.titulaire !=''){
                    this.$dialog.confirm({
                      text: "Ligne active sur le contrat "+res.params.contrat+" - titulaire "+res.params.titulaire+"! Vous allez procéder à une migration, voulez-vous continuer ?",
                      type:'warning',
                      title: 'Alert',
                      actions: {
                        false: 'Non',
                        true: {
                          color: 'red',
                          text: 'Oui',
                          handle: () => {
                            this.saveInSession(resultCheckRio);
                          }
                        }
                      }
                    })


              }else
                this.saveInSession(resultCheckRio);

              
              
            }else{
              this.$dialog.error({
                text: res.err_msg,
                title: 'Erreur',
                persistent: false,
                actions: {
                  false: 'Fermer'
                }
              })
            
            }
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$dialog.notify.error(this.$root.errorMessage, {
            position: "bottom-right",
            timeout: 5000,
          });
          return error;
        });

      }

    },
    saveInSession: function(resultCheckRio){
       
        // enregistrement du numFixe en session
        const sessionSouscription = this.$globalService.setSessionSouscription("resultCheckRio",resultCheckRio);
        if (sessionSouscription== null || !sessionSouscription.resultCheckRio) {
          this.$dialog.error({
            text: "Une erreur s'est produite - 3589",
            title: "Erreur",
            persistent: false,
            actions: {
              false: "Fermer",
            },
          });
          return;
        } else{
          this.$globalService.setSessionSouscription('numFixe',this.numFixe);
          this.$globalService.setSessionSouscription('codeRIO',this.codeRIO);
          
          this.$router.push({ name: "Recap" });
        }
    }
  },
};
</script>

<style>
#reponse .sel {
  background-color: var(--v-primary-base);
  color: white;
}
.poursuivre{
  background-image: linear-gradient(to right,var(--v-violet-base) 0,var(--v-rubine-base) 100%);
  color:white !important;
}
</style>